/*----- AUTH users -------------------------------------------------------------------*/
export default {
    status: "",
    current_user: JSON.parse(localStorage.getItem("currentUser")) || {
        permissions: [],
        roles: [],
        image: "",
        branch: {}
    },
    token: localStorage.getItem("auth_token") || ""
};
